import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountLogout" })
export default class AccountLogout extends Vue {
    public localizer: any = Localizer;

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async logout() {
        localStorage.removeItem("token");

        await Axios.post(this.routes.Account_User_Logout, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

        window.location.href = this.returnUrl ? this.returnUrl : "/";
    }
};